import axios from "axios"

// Base URL .env se le rahe hain (tumhara backend)
const API_URL = process.env.REACT_APP_API_URL || "https://omni.unfilteredmoney.com/api"

const axiosApi = axios.create({
  baseURL: API_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
})

// Global error handler (rakho – bahut useful hai)
axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

// Helper functions – yeh sab rakho
export async function get(url, config = {}) {
  return await axiosApi.get(url, { ...config }).then(response => response.data)
}

export async function post(url, data, config = {}) {
  return axiosApi.post(url, data, { ...config }).then(response => response.data)
}

export async function put(url, data, config = {}) {
  return axiosApi.put(url, data, { ...config }).then(response => response.data)
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}

// // ────── Import real endpoint from url_helper ──────
// import { POST_UPLOAD } from "./url_helper"

// // ==================== 1. UPLOAD FILE (updated for better error & success handling) ====================
// export const uploadFile = async file => {
//   if (!file) {
//     return { success: false, error: "No file selected" }
//   }

//   const validTypes = [
//     "text/csv",
//     "application/vnd.ms-excel",
//     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   ]

//   if (
//     !validTypes.includes(file.type) &&
//     !file.name.match(/\.(csv|xlsx|xls)$/i)
//   ) {
//     return {
//       success: false,
//       error:
//         "Invalid file type. Only CSV or Excel (.xlsx/.xls) files are allowed.",
//     }
//   }

//   const formData = new FormData()
//   formData.append("file", file)

//   try {
//     const response = await axiosApi.post(POST_UPLOAD, formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     })

//     const resData = response.data

//     // Success case – backend se aaya response use kar rahe hain
//     let successMessage = `File uploaded successfully!`
//     if (resData.new_uploaded !== undefined) {
//       successMessage += ` ${resData.new_uploaded} new transactions added.`
//     }
//     if (resData.total_in_database !== undefined) {
//       successMessage += ` Total transactions now: ${resData.total_in_database}.`
//     }
//     if (resData.duplicates_skipped > 0) {
//       successMessage += ` ${resData.duplicates_skipped} duplicates skipped.`
//     }
//     if (resData.auto_corrected_types > 0) {
//       successMessage += ` ${resData.auto_corrected_types} transaction types auto-corrected.`
//     }

//     return {
//       success: true,
//       data: resData,
//       message: successMessage,
//     }
//   } catch (error) {
//     let errorMsg = "Upload failed. Please try again."
//     let details = null

//     if (error.response?.data) {
//       const err = error.response.data

//       // Backend ke naye error messages ko handle kar rahe hain
//       if (err.error) {
//         errorMsg = err.error
//       }

//       // Missing columns wala case
//       if (err.missing_columns) {
//         details = `Missing required columns: ${err.missing_columns.join(
//           ", "
//         )}. Please check your file.`
//       }

//       // Invalid TransactionType wala case
//       if (err.total_invalid && err.sample) {
//         details = `Found ${err.total_invalid} rows with invalid TransactionType. Example rows:\n`
//         err.sample.forEach(item => {
//           details += `- Row ${item.row}: TransactionID ${item.transaction_id}, Given Type: "${item.given_type}"\n`
//         })
//       }

//       // General details
//       if (err.details) {
//         details = err.details
//       }
//     } else if (error.message) {
//       errorMsg = error.message
//     }

//     return { success: false, error: errorMsg, details }
//   }
// }

// ────── Import real endpoint from url_helper ──────
import { POST_UPLOAD } from "./url_helper"

// ==================== UPLOAD FILE (clean & user-friendly error messages) ====================
export const uploadFile = async file => {
  if (!file) {
    return { success: false, error: "No file selected" }
  }

  const validTypes = [
    "text/csv",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ]

  if (
    !validTypes.includes(file.type) &&
    !file.name.match(/\.(csv|xlsx|xls)$/i)
  ) {
    return {
      success: false,
      error: "Only CSV or Excel (.xlsx / .xls) files are allowed.",
    }
  }

  const formData = new FormData()
  formData.append("file", file)

  try {
    const response = await axiosApi.post(POST_UPLOAD, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })

    const resData = response.data

    // Success message – short & meaningful
    let successMessage = "File uploaded successfully!"
    if (resData.new_uploaded !== undefined) {
      successMessage += ` ${resData.new_uploaded} new entries added.`
    }
    if (resData.duplicates_skipped > 0) {
      successMessage += ` ${resData.duplicates_skipped} duplicates skipped.`
    }
    if (resData.auto_corrected_types > 0) {
      successMessage += ` ${resData.auto_corrected_types} types auto-corrected.`
    }
    if (resData.total_in_database !== undefined) {
      successMessage += ` Total records now: ${resData.total_in_database}.`
    }

    return {
      success: true,
      data: resData,
      message: successMessage.trim(),
    }
  } catch (error) {
    let errorMsg = "Upload failed. Please try again."
    let details = null

    if (error.response?.data) {
      const err = error.response.data

      // 1. Missing columns – sirf missing columns ka naam dikhao
      if (err.missing_columns && Array.isArray(err.missing_columns)) {
        if (err.missing_columns.length === 1) {
          errorMsg = `Missing required column: ${err.missing_columns[0]}`
        } else {
          errorMsg = `Missing required columns: ${err.missing_columns.join(
            ", "
          )}`
        }
        details =
          "Please make sure your file has all required columns and try again."
      }

      // 2. Invalid TransactionType rows
      else if (err.total_invalid && err.sample) {
        errorMsg = `Found ${err.total_invalid} rows with invalid TransactionType.`
        details = "Examples:\n"
        err.sample.forEach(item => {
          details += `- Row ${item.row_number || item.row}: ID ${
            item.transaction_id
          }, Type: "${item.given_type || "unknown"}"\n`
        })
        details += "\nPlease correct these in your file."
      }

      // 3. General backend error
      else if (err.error) {
        errorMsg = err.error
        if (err.details) details = err.details
      }
    } else if (error.message) {
      errorMsg = error.message
    }

    return { success: false, error: errorMsg, details }
  }
}

import { POST_DELETE } from "./url_helper"
export const deleteData = async ({
  date = null,
  startDate = null,
  endDate = null,
  mobileNumber = null,
  confirmAll = false,
} = {}) => {
  const hasFilter = date || (startDate && endDate) || mobileNumber

  if (!hasFilter && !confirmAll) {
    return {
      success: false,
      error:
        "Please provide at least one filter or set confirmAll=true to delete all data.",
    }
  }

  const formData = new FormData()

  if (date) formData.append("date", date)
  if (startDate && endDate) {
    formData.append("start_date", startDate)
    formData.append("end_date", endDate)
  }
  if (mobileNumber) formData.append("mobile_number", mobileNumber.trim())
  if (confirmAll) formData.append("confirm_all", "yes")

  console.log(
    "[DEBUG deleteData] FormData being sent:",
    Object.fromEntries(formData.entries())
  )

  try {
    const response = await axiosApi.post(POST_DELETE, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })

    console.log("[DEBUG deleteData] Raw response:", response)
    console.log("[DEBUG deleteData] Response data:", response.data)

    const data = response.data

    // Backend success response structure ke hisaab se check
    if (data.status === "success" || data.deleted !== undefined) {
      return {
        success: true,
        message:
          data.message ||
          `Deleted ${data.deleted || 0} records. Remaining: ${
            data.total_remaining || "unknown"
          }`,
        data,
      }
    } else {
      // Error case
      return {
        success: false,
        error:
          data.error ||
          data.detail ||
          data.message ||
          "Delete failed - unknown reason from backend",
        details: data.warning || data.details || null,
      }
    }
  } catch (error) {
    console.error("[DELETE ERROR] Full error:", error)
    console.error("[DELETE ERROR] Response data:", error.response?.data)
    console.error("[DELETE ERROR] Status code:", error.response?.status)

    let errorMsg = "Failed to delete data - unknown error"
    let details = null

    if (error.response?.data) {
      const errData = error.response.data
      errorMsg =
        errData.error ||
        errData.detail ||
        errData.message ||
        errData.non_field_errors?.[0] ||
        errorMsg
      details = errData.warning || errData.details || null
    } else if (error.message?.includes("Network")) {
      errorMsg =
        "Network error - backend not reachable? Check if server is running."
    } else if (error.message?.includes("CORS")) {
      errorMsg =
        "CORS error - backend origin not allowed. Check Django CORS settings."
    }

    return { success: false, error: errorMsg, details }
  }
}

// ────── Naya function: Combined Report API ──────
export const getCombinedTransactionReport = async ({
  startDate = null, // YYYY-MM-DD
  endDate = null, // YYYY-MM-DD
  mobileNumber = null, // string ya comma-separated string (single ya multiple)
  limit = 50,
  offset = 0,
} = {}) => {
  try {
    // Query parameters object banao
    const params = {
      limit,
      offset,
    }

    if (startDate) params.start_date = startDate
    if (endDate) params.end_date = endDate
    if (mobileNumber) {
      // Agar array hai to join kar do, warna direct string
      params.mobile_number = Array.isArray(mobileNumber)
        ? mobileNumber.join(",")
        : mobileNumber
    }

    console.log("[DEBUG getCombinedReport] Sending params:", params)

    const response = await axiosApi.get("/trnsaction/", { params })

    console.log("[DEBUG getCombinedReport] Raw response:", response.data)

    const data = response.data

    // Backend success check
    if (data.status === "success") {
      return {
        success: true,
        data: data.data || {}, // main grouped data
        processed: data.processed || 0,
        totalRecords: data.total_records || 0,
        nextOffset: data.next_offset || null,
        message: `Fetched ${data.processed} records (total ${data.total_records})`,
      }
    } else {
      return {
        success: false,
        error: data.error || "Unknown response from backend",
        details: data,
      }
    }
  } catch (error) {
    console.error("[GET COMBINED REPORT ERROR] Full error:", error)

    let errorMsg = "Failed to fetch transaction report"
    let details = null

    if (error.response?.data) {
      const errData = error.response.data
      errorMsg =
        errData.error ||
        errData.exception ||
        errData.detail ||
        errData.message ||
        errorMsg
      details = errData.traceback || errData.details || null
    } else if (error.message?.includes("Network")) {
      errorMsg = "Network error - backend not reachable?"
    } else if (error.message?.includes("CORS")) {
      errorMsg = "CORS issue - check Django CORS settings"
    }

    return { success: false, error: errorMsg, details }
  }
}

export const getTotals = async (filters = {}) => {
  try {
    const params = {}

    // Date filters
    if (filters.startDate) params.start_date = filters.startDate
    if (filters.endDate) params.end_date = filters.endDate

    // Mobile numbers (comma separated)
    if (filters.mobileNumbers?.length > 0) {
      params.mobile_number = filters.mobileNumbers.join(",")
    }

    console.log("[getTotals] Sending params:", params)

    const response = await get("/totals/", { params })

    console.log("[getTotals] Raw response:", response)

    if (response.status === "success") {
      return {
        success: true,
        totals: response.totals || {},
        breakdown: response.breakdown || {},
        message: "Totals fetched successfully",
      }
    } else {
      return {
        success: false,
        error: response.error || "Failed to fetch totals",
        details: response,
      }
    }
  } catch (error) {
    console.error("[getTotals ERROR]:", error)

    let errorMsg = "Failed to fetch totals"
    let details = null

    if (error.response?.data) {
      const errData = error.response.data
      errorMsg = errData.error || errData.details || errorMsg
      details = errData.traceback || null
    } else if (error.message?.includes("Network")) {
      errorMsg = "Network error - backend not reachable"
    }

    return { success: false, error: errorMsg, details }
  }
}

import { POST_REGISTER, POST_LOGIN } from "./url_helper"

// ==================== REGISTER USER ====================
export const registerUser = async userData => {
  // Input validation (frontend pe basic check)
  if (!userData.username || !userData.email || !userData.password) {
    return {
      success: false,
      error:
        "Please fill all required fields: username, email, password, full name",
    }
  }

  try {
    const response = await axiosApi.post(POST_REGISTER, userData)

    return {
      success: true,
      data: response.data,
      message:
        response.data.message || "Registration successful! You can now login.",
    }
  } catch (error) {
    let errorMsg = "Registration failed. Please try again."
    let details = null

    if (error.response?.data) {
      const err = error.response.data
      errorMsg = Object.values(err).flat().join(" ") || errorMsg // serializer errors ko join karke dikhao
      details = err // full error object bhej sakte ho
    } else if (error.message) {
      errorMsg = error.message
    }

    return { success: false, error: errorMsg, details }
  }
}

// ==================== LOGIN USER ====================
export const loginUser = async credentials => {
  // Basic validation
  if (!credentials.username || !credentials.password) {
    return {
      success: false,
      error: "Username and password are required",
    }
  }

  try {
    const response = await axiosApi.post(POST_LOGIN, credentials)

    const resData = response.data

    // Success – tokens aur user info store kar sakte ho (localStorage ya context mein)
    if (resData.access && resData.refresh) {
      // Optional: localStorage mein save kar do (ya context/redux mein)
      localStorage.setItem("accessToken", resData.access)
      localStorage.setItem("refreshToken", resData.refresh)
      localStorage.setItem("user", JSON.stringify(resData.user))
    }

    return {
      success: true,
      data: resData,
      message: "Login successful!",
      tokens: {
        access: resData.access,
        refresh: resData.refresh,
      },
      user: resData.user,
    }
  } catch (error) {
    let errorMsg = "Login failed. Please check your credentials."
    let details = null

    if (error.response?.data) {
      const err = error.response.data
      errorMsg = err.error || "Invalid username or password"
      details = err
    } else if (error.message) {
      errorMsg = error.message
    }

    return { success: false, error: errorMsg, details }
  }
}

export const getTotalRecordsCount = async (filters = {}) => {
  try {
    const params = {}

    // Agar future mein filters add hone chahiye (jaise date range se filtered count), to yahan add kar sakte ho
    // Abhi is endpoint mein filters nahi hain, lekin structure same rakha hai
    if (filters.startDate) params.start_date = filters.startDate
    if (filters.endDate) params.end_date = filters.endDate
    if (filters.mobileNumbers?.length > 0) {
      params.mobile_number = filters.mobileNumbers.join(",")
    }

    console.log("[getTotalRecordsCount] Sending params:", params)

    const response = await get("/total-records/", { params })

    console.log("[getTotalRecordsCount] Raw response:", response)

    if (response.status === "success") {
      return {
        success: true,
        totalRecords: response.total_records_in_database || 0,
        timestamp: response.timestamp || new Date().toISOString(),
        message: response.message || "Total records fetched successfully",
      }
    } else {
      return {
        success: false,
        error: response.error || "Failed to fetch total records count",
        details: response,
      }
    }
  } catch (error) {
    console.error("[getTotalRecordsCount ERROR]:", error)

    let errorMsg = "Failed to fetch total records count"
    let details = null

    if (error.response?.data) {
      const errData = error.response.data
      errorMsg = errData.error || errData.details || errorMsg
      details = errData.traceback || null
    } else if (error.message?.includes("Network")) {
      errorMsg = "Network error - backend not reachable"
    }

    return { success: false, error: errorMsg, details }
  }
}
